import { EBitfStoreActions } from '@common/enums';
export enum EWebStoreActions {
  NEW_WEB_ACTION = 'NEW_WEB_ACTION',
}

export const eStoreActions = { ...EBitfStoreActions, ...EWebStoreActions };
